import { render, staticRenderFns } from "./AssignAppsR.vue?vue&type=template&id=c8a9d6ba&scoped=true"
import script from "./AssignAppsR.vue?vue&type=script&lang=js"
export * from "./AssignAppsR.vue?vue&type=script&lang=js"
import style0 from "./AssignAppsR.vue?vue&type=style&index=0&id=c8a9d6ba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a9d6ba",
  null
  
)

export default component.exports